import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { lastValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProgressService {
  private toastSubject = new BehaviorSubject<any>({ isVisible: false });
  public toastObservable = this.toastSubject.asObservable();

  constructor(private facturasCargar: HttpClient) {}

  // Mostrar la notificación
  showToast(message: string, icon: string = 'info', timer: number = 3000, progress: number = 0, cantidadFacturas: number = 0) {
    this.toastSubject.next({ isVisible: true, message, icon, timer, progress, cantidadFacturas });
  }

  // Actualizar el progreso
  updateProgress(progress: number) {
    const currentToast = this.toastSubject.getValue();
    if (currentToast.isVisible) {
      this.toastSubject.next({ ...currentToast, progress });
    }
  }

  // Ocultar la notificación
  hideToast() {
    this.toastSubject.next({ isVisible: false });
  }

  // Ejecutar la lógica de intervalo con progreso
  async ejecutarConIntervalo() {
    // Inicializa la notificación con un mensaje "Procesando..."
    this.showToast('Procesando...', 'info', 100000, 0);

    for (let i = 1; i <= 100; i++) {
      // Actualizar el progreso en la notificación
      this.showToast('Procesando...', 'info', 100000, i); // Aquí actualizas el progreso

      // Simula el tiempo de procesamiento
      await new Promise((resolve) => setTimeout(resolve, 100));
    }

    // Finaliza el proceso con una notificación de éxito
    this.showToast('Proceso completado con éxito!', 'check_circle', 3000, 100);
  }

  async onUpload(event: { files: File[] }): Promise<void> {
    const files: File[] = event.files;

    // Crear un arreglo de promesas para procesar los archivos
    const filePromises = files.map((file) => {
      return new Promise<void>((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = async () => {
          const fileContent = reader.result as string;
          // Parsear el XML
          const parser = new DOMParser();
          const xmlDoc = parser.parseFromString(fileContent, 'text/xml');
          const facturasXML: string[] = [];

          // Obtener todas las etiquetas <factura>
          const facturas = xmlDoc.getElementsByTagName('factura');
          for (let i = 0; i < facturas.length; i++) {
            facturasXML.push(facturas[i].outerHTML); // Asegúrate de usar 'i' para acceder a cada 'factura'
          }
          const totalFacturas = facturasXML.length;
          let processedFacturas = 0;
          this.showToast('Procesando...', 'info', 100000, 0, facturas.length);
          // Proceso cada factura en paralelo usando Promise.all
          const promises = facturasXML.map(async (facturaXML, index) => {
            const xmlDoc = parser.parseFromString(facturaXML, 'text/xml');
            const claveAcceso = xmlDoc.getElementsByTagName('claveAcceso')[0]?.textContent || 'N/A';
            let numeroComprobante = claveAcceso;
            if (claveAcceso !== 'N/A' && claveAcceso.length >= 39) {
              numeroComprobante = `${claveAcceso.slice(24, 27)}-${claveAcceso.slice(27, 30)}-${claveAcceso.slice(30, 39)}`;
            }
            const razonSocialComprador = xmlDoc.getElementsByTagName('razonSocialComprador')[0]?.textContent || 'N/A';
            //Arreglar
            const valorFactura = xmlDoc.getElementsByTagName('total')[0]?.textContent || 'N/A';
            const estadoinicialFacturaElemento = xmlDoc.createElement('estadoFactura');
            xmlDoc.documentElement.appendChild(estadoinicialFacturaElemento);
            const estadoinicialMetodoPago = xmlDoc.createElement('metodoPago');
            xmlDoc.documentElement.appendChild(estadoinicialMetodoPago);
            const serializer = new XMLSerializer();
            const facturaXMLModificado = serializer.serializeToString(xmlDoc);
            const parametros = { data: facturaXMLModificado };

            try {
              const respuesta = await lastValueFrom(
                this.facturasCargar.post<{ codigo: number; data: string; error: string }>(
                  'http://192.168.0.32:4200/api/cheqex/guardarFactura',
                  parametros
                )
              );
              processedFacturas++;
              this.showToast('Procesando...', 'info', 100000, processedFacturas, facturas.length);

              if (respuesta.codigo == 1) {
                /*this.informacionFacturasCargadasError.push({
                  numeroComprobante,
                  razonSocialComprador,
                  valorFactura,
                  mensaje: 'La factura fue creada con éxito',
                  icono: 0
                });*/
              } else {
                /*this.informacionFacturasCargadasError.push({
                  numeroComprobante,
                  razonSocialComprador,
                  valorFactura,
                  mensaje: respuesta.error,
                  icono: 1
                });*/
              }
            } catch (error) {
              console.error('Error al cargar la factura:', error);

              if (error == 'Unknown Error') {
                /*this.informacionFacturasCargadasError.push({
                  numeroComprobante,
                  razonSocialComprador,
                  valorFactura,
                  mensaje: 'Error en servicio, intente nuevamente',
                  icono: 1
                });*/
              } else {
                /*this.informacionFacturasCargadasError.push({
                  numeroComprobante,
                  razonSocialComprador,
                  valorFactura,
                  mensaje: error?.toString() || 'Error desconocido',
                  icono: 1
                });*/
              }
            }
          });

          // Esperar que todas las promesas de facturas se resuelvan
          await Promise.all(promises);
          this.showToast('Proceso completado con éxito!', 'check_circle', 3000, 100);

          resolve(); // Resolviendo la promesa una vez que todo el archivo haya sido procesado
        };

        reader.onerror = () => {
          console.error('Error leyendo el archivo', file.name);
          reject(new Error('Error leyendo el archivo.'));
        };

        // Leer el archivo como texto
        reader.readAsText(file);
      });
    });

    // Esperar que todos los archivos se procesen
    await Promise.all(filePromises);
    console.log('Todos los archivos se han procesado.');
  }
}
